import { AxiosResponse } from 'axios';
import { IRoom } from 'src/utils/types';
import { Service } from 'typedi';
import { axios } from '../axios';
import { ShowNotification } from '../ShowNotification';

@Service()
export class RoomRequest {
  @ShowNotification()
  getRooms(): Promise<AxiosResponse<IRoom[]>> {
    return axios.get('picklist/conference-rooms');
  }
}
